import api from '../../api/_stock'

const state = () => ({
    
    stocks: [],
    stock: [],
    liste_articles_attente_de_retour: []

})

// getters
const getters = {
    stocks: (state) => {
        return state.stocks
    },
    
    stockage: (state) => {
        return state.stocks
    },

    stock: (state) => {
        return state.stock
    },

    liste_articles_attente_de_retour: (state) => {
        return state.liste_articles_attente_de_retour
    },
}

// mutations
const mutations = {
    
    SET_STOCKS(state, stocks) {
        state.stocks = stocks
    },


    SET_STOCKAGE(state, stocks) {
        state.stocks = stocks
    },

    SET_STOCK(state, stock) {
        state.stock = stock
    },

    SET_DESTOCKAGE(state, stock) {
        state.stock = stock
    },

    SET_LISTE_ARTICLES_ATTENTE_DE_RETOUR(state, liste) {
        state.liste_articles_attente_de_retour = liste
    },
}

// actions
const actions = {
    
    getStocks({ commit }) {
        return new Promise((resolve, reject) => {
          api.getStocks().then(
            (response) => {
              commit("SET_STOCKS", response);
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
    },

    stockage({commit}) {
        api.stockage().then(
            response => {
                commit('SET_STOCKAGE', response)
            }
        )
    },

    async saveStock ({commit}, data) {
        return api.saveStock(data).then(
            response => {
                commit('SET_STOCK', response)

                return true
            }
        )
    },
    async saveDestockage ({commit}, data) {
        return api.saveDestockage(data).then(
            response => {
                commit('SET_DESTOCKAGE', response)

                return true
            }
        )
    },


    getStock({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getStock(id).then(
                (response) => {
                    commit("SET_STOCK", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // destockage ({commit}, id) {
    //     api.destockage(id).then(
    //         response => {
    //             commit('SET_STOCK', response)
    //         }
    //     )
    // },

    addArticleStock ({commit}, data) {
        api.addArticle(data).then(
            response => {
                commit('SET_STOCK', response)
            }
        )
    },

    deleteArticle ({commit}, id) {
        api.deleteArticle(id).then(
            response => {
                commit('SET_STOCK', response)
            }
        )
    },

    async editStock ({commit, dispatch}, {id, data}) {
        return api.editStock(id, data).then(
            response => {
                commit('SET_STOCK', response)
                dispatch('getStocks')
                return true
            }
        )
    },

    deleteStock ({commit}, id) {
        api.deleteStock(id).then(
            response => {
                commit('SET_DESTOCKAGE', response)
            }
        )
    },

    getListeArticleEnAttenteRetour({ commit }, id) {
        return new Promise((resolve, reject) => {
            api.getListeArticleEnAttenteRetour(id).then(
                (response) => {
                    commit("SET_LISTE_ARTICLES_ATTENTE_DE_RETOUR", response);
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    saveConfirmationRetourStock({ dispatch }, data) {
        return new Promise((resolve, reject) => {
            api.saveConfirmationRetourStock(data).then(
                (response) => {
                    dispatch;
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

}



export default {
  state,
  getters,
  actions,
  mutations
}
